// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NW4a","index":"styles_index__2bmju"};